import styled from 'styled-components';

export const GuestPage = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: var(--blue-300);
`;

export default GuestPage;
